import { defineStore } from 'pinia'
import { ref } from 'vue'

export interface HeaderBreadcrumb {
  label: string
  route: string
}

export const useHeaderStore = defineStore('header', () => {
  const title = ref('')
  const subtitle = ref('')
  const breadcrumbs = ref<HeaderBreadcrumb[]>([])

  function setTitle(
    newTitle: string,
    newSubtitle: string = '',
    newBreadcrumb: HeaderBreadcrumb | HeaderBreadcrumb[] | null = null
  ) {
    title.value = newTitle
    subtitle.value = newSubtitle

    if (newBreadcrumb === null) {
      breadcrumbs.value = []
    } else if (Array.isArray(newBreadcrumb)) {
      breadcrumbs.value = newBreadcrumb
    } else {
      breadcrumbs.value = [newBreadcrumb]
    }
  }

  function clearTitle() {
    title.value = ''
    subtitle.value = ''
    breadcrumbs.value = []
  }

  return {
    title,
    subtitle,
    breadcrumbs,
    setTitle,
    clearTitle
  }
})
